<template>
    <div class="format-date">
        {{ convertDate() }}
    </div>
</template>

<script>
import { fomatDateTimeLocal, formatDateTimeLocalKintone } from '@/utils';

export default {
    name: 'FormatDate',
    props: {
        date: {
            require: true
        },
        format: String,
        isKintone: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'date',
        event: 'update'
    },
    data() {
        return {};
    },
    methods: {
        convertDate() {
            if (!this.date) return '';
            let date = this.date;
            return this.isKintone ? formatDateTimeLocalKintone(this.format, date) : fomatDateTimeLocal(this.format, date);
        }
    }
};
</script>

<style lang="scss"></style>
